import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "./styles.css";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import "leaflet-routing-machine/dist/leaflet-routing-machine.js";

const MapaCatastro = ({
  setLatitud,
  setLongitud,
  latitud = 9.549884372804192,
  longitud = -69.20455936500002,
}) => {
  const contenedor = useRef(null);
  const mapaInstancia = useRef(null);
  const markerRef = useRef(null);

  const customIcon = L.icon({
    iconUrl: "/imagenes/marker-icon.png",
    iconRetinaUrl: "/imagenes/marker-icon-2x.png",
    shadowUrl: "/imagenes/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
  });

  // 1. EFECTO PRINCIPAL: Inicialización del mapa
  useEffect(() => {
    if (!contenedor.current || mapaInstancia.current) return;

    mapaInstancia.current = L.map(contenedor.current).setView(
      [latitud, longitud],
      12,
    );

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
    }).addTo(mapaInstancia.current);

    markerRef.current = L.marker([latitud, longitud], {
      icon: customIcon,
    }).addTo(mapaInstancia.current);

    mapaInstancia.current.on("click", (e) => {
      const { lat, lng } = e.latlng;
      if (markerRef.current) {
        markerRef.current.setLatLng([lat, lng]);
        mapaInstancia.current.panTo([lat, lng]);
      }
      setLatitud(lat);
      setLongitud(lng);
    });

    return () => {
      if (mapaInstancia.current) {
        mapaInstancia.current.remove();
        mapaInstancia.current = null;
      }
    };
  }, []);
  useEffect(() => {
    if (!contenedor.current) return;

    const observador = new ResizeObserver(() => {
      if (mapaInstancia.current) {
        // 1. Arregla el problema del mapa gris
        mapaInstancia.current.invalidateSize();

        mapaInstancia.current.setView([latitud, longitud], 12);
      }
    });

    observador.observe(contenedor.current);

    return () => {
      observador.disconnect();
    };
  }, [latitud, longitud]);

  useEffect(() => {
    if (mapaInstancia.current && markerRef.current) {
      const posicionActual = markerRef.current.getLatLng();
      if (posicionActual.lat !== latitud || posicionActual.lng !== longitud) {
        const nuevasCoordenadas = [latitud, longitud];
        markerRef.current.setLatLng(nuevasCoordenadas);
        mapaInstancia.current.panTo(nuevasCoordenadas);
        mapaInstancia.current.invalidateSize();
      }
    }
  }, [latitud, longitud]);

  return (
    <div>
      <div className="px-auto mx-auto">
        <div ref={contenedor} style={{ height: "300px", width: "100%" }} />
      </div>
    </div>
  );
};

export default MapaCatastro;
